import React from "react";
import ReactDOM from "react-dom/client";
import {
    ChakraProvider,
    defaultSystem,
} from "@chakra-ui/react";
import { Provider } from "react-redux";
import "mapbox-gl/dist/mapbox-gl.css";
import "./index.css";
import App from "./App";
import store from "./state/store";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
    document.getElementById("root")
);

root.render(
    <React.StrictMode>
         <Provider store={store}>
        <ChakraProvider value={defaultSystem}>
            <App />
        </ChakraProvider>
        </Provider>
    </React.StrictMode>
);

reportWebVitals();